export default function backdropLogin() {
  return `
     <div class="auth__backdrop">
      <div class="auth__wrap"><!-- тут будет модалка --></div>
    </div>`;
}
